/**
 * 周几复选：1-7（周一~周日），与 legal_date 的 targeting_id="1、2、3、4、5" 对应。
 */
interface Props {
  selected: number[];
  onChange: (n: number[]) => void;
}

const WEEKDAYS: { n: number; label: string }[] = [
  { n: 1, label: "一" },
  { n: 2, label: "二" },
  { n: 3, label: "三" },
  { n: 4, label: "四" },
  { n: 5, label: "五" },
  { n: 6, label: "六" },
  { n: 7, label: "日" },
];

export function WeekdayCheckboxes({ selected, onChange }: Props) {
  function toggle(n: number) {
    if (selected.includes(n)) onChange(selected.filter((x) => x !== n));
    else onChange([...selected, n].sort((a, b) => a - b));
  }

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {WEEKDAYS.map((d) => {
        const on = selected.includes(d.n);
        return (
          <button
            key={d.n}
            type="button"
            onClick={() => toggle(d.n)}
            className={`leo-sideitem h-9 w-9 justify-center ${on ? "is-active" : ""}`}
            title={`周${d.label}`}
          >
            {d.label}
          </button>
        );
      })}
    </div>
  );
}
